import { useContext } from 'react';
import { RBACDataContext } from '../../components/layout/rbac-data-context';

export const useRBACDataContext = () => {
  const context = useContext(RBACDataContext);
  if (!context) {
    throw new Error('useRBACDataContext must be used within RBACDataProvider');
  }
  return context;
};